import { createContext, ReactNode } from "react";
import { GlobalBaseData } from "../main";

const BaseContext = createContext<GlobalBaseData | undefined>(undefined);

const BaseProvider = ({
  children,
  data,
}: {
  children: ReactNode;
  data?: GlobalBaseData;
}) => {
  return <BaseContext.Provider value={data}>{children}</BaseContext.Provider>;
};

export { BaseContext, BaseProvider };
